module.exports = __webpack_public_path__ + "static/img/2_5_1.bfdd7c24.jpg";